import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider";
import { getLowFareHotels } from "../../Services/HotelSearchApi";
import * as XLSX from "xlsx";

const LowFareHotels = () => {
  const { userName } = useContext(AuthContext);
  const [globalSearch, setGlobalSearch] = useState("");
  const [filters, setFilters] = useState({
    referenceNo: "",
    fromDate: "",
    toDate: "",
  });
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 20;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const convertToDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const formatDateForApi = (dateStr, isEnd = false) => {
    if (!dateStr) return undefined;
    const dateObj = convertToDate(dateStr);
    if (!dateObj || isNaN(dateObj.getTime())) return undefined;

    const pad = (num) => String(num).padStart(2, '0');
    const year = dateObj.getFullYear();
    const month = pad(dateObj.getMonth() + 1);
    const day = pad(dateObj.getDate());
    const hours = isEnd ? "23" : "00";
    const minutes = isEnd ? "59" : "00";
    const seconds = isEnd ? "59" : "00";
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    $("#fromDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          fromDate: dateText,
        }));
      },
    });

    $("#toDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          toDate: dateText,
        }));
      },
    });
  }, []);

  useEffect(() => {
    if (filters.fromDate) {
      const minD = convertToDate(filters.fromDate);
      $("#toDate").datepicker("option", "minDate", minD);
    }
  }, [filters.fromDate]);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const fromDateParam = formatDateForApi(filters.fromDate, false);
      const toDateParam = formatDateForApi(filters.toDate, true);

      const params = {
        referenceNo: filters.referenceNo || undefined,
        createdBy: userName || undefined,
        fromDate: fromDateParam,
        toDate: toDateParam,
        corporateCode: "",
        corporateName: "",
      };

      const res = await getLowFareHotels(params);
      let list = [];
      if (Array.isArray(res)) {
        list = res;
      } else if (res?.records && Array.isArray(res.records)) {
        list = res.records;
      } else if (res?.data?.records && Array.isArray(res.data.records)) {
        list = res.data.records;
      } else if (res?.data && Array.isArray(res.data)) {
        list = res.data;
      } else if (res?.logs && Array.isArray(res.logs)) {
        list = res.logs;
      } else if (res?.lowFareHotels && Array.isArray(res.lowFareHotels)) {
        list = res.lowFareHotels;
      }

      //console.log("Extracted Low Fare Hotels Log List:", list);
      setTransactions(list);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching low fare hotels log:", error);
      alert("Failed to fetch low fare hotels log. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClear = async () => {
    const clearedFilters = {
      referenceNo: "",
      fromDate: "",
      toDate: "",
    };
    setFilters(clearedFilters);
    $("#fromDate").val("");
    $("#toDate").val("");
    $("#toDate").datepicker("option", "minDate", null);

    setLoading(true);
    try {
      const params = {
        createdBy: userName || undefined,
        corporateCode: "",
        corporateName: "",
      };
      const res = await getLowFareHotels(params);
      let list = [];
      if (Array.isArray(res)) {
        list = res;
      } else if (res?.records && Array.isArray(res.records)) {
        list = res.records;
      } else if (res?.data?.records && Array.isArray(res.data.records)) {
        list = res.data.records;
      } else if (res?.data && Array.isArray(res.data)) {
        list = res.data;
      } else if (res?.logs && Array.isArray(res.logs)) {
        list = res.logs;
      } else if (res?.lowFareHotels && Array.isArray(res.lowFareHotels)) {
        list = res.lowFareHotels;
      }
      setTransactions(list);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error clearing and fetching:", error);
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    if (userName) {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);

  // Local search filter
  const filteredTransactions = transactions.filter((item) => {
    if (!globalSearch) return true;
    const term = globalSearch.toLowerCase();
    const ref = (item.referenceNo || item.ReferenceNo || "").toLowerCase();
    const selectedHotel = (item.selectedHotelName || item.SelectedHotelName || "").toLowerCase();
    const recommendedHotel = (item.recommendedHotelName || item.RecommendedHotelName || "").toLowerCase();
    const corpName = (item.corporateName || item.CorporateName || "").toLowerCase();
    const corpCode = (item.corporateCode || item.CorporateCode || "").toLowerCase();
    const creator = (item.createdBy || item.CreatedBy || "").toLowerCase();
    const remark = (item.remark || item.Remark || "").toLowerCase();
    const selectedOption = (item.selectedOption || "").toLowerCase();
    return (
      ref.includes(term) ||
      selectedHotel.includes(term) ||
      recommendedHotel.includes(term) ||
      corpName.includes(term) ||
      corpCode.includes(term) ||
      creator.includes(term) ||
      remark.includes(term) ||
      selectedOption.includes(term)
    );
  });

  const handleExportExcel = () => {
    const dataToExport = filteredTransactions.map((item, index) => ({
      "Sr No": index + 1,
      "Reference No": item.referenceNo || item.ReferenceNo || "",
      "Created On": item.createdOn || item.CreatedOn
        ? new Date(item.createdOn || item.CreatedOn).toLocaleString("en-GB")
        : "",
      "Corporate Name": item.corporateName || item.CorporateName || "",
      "Corporate Code": item.corporateCode || item.CorporateCode || "",
      "Selected Hotel Name": item.selectedHotelName || item.SelectedHotelName || "",
      "Selected Price": item.selectedPrice || item.SelectedPrice || 0,
      "Recommended Hotel Name": item.recommendedHotelName || item.RecommendedHotelName || "",
      "Recommended Price": item.recommendedPrice || item.RecommendedPrice || 0,
      "Option Selected": item.selectedOption || "",
      "Saved Price": item.savingPrice || item.SavingPrice || 0,
      "Missed Price": item.missingPrice || item.MissingPrice || 0,
      "Created By": item.createdBy || item.CreatedBy || "",
      "Remark": item.remark || item.Remark || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "LowFareHotels");
    XLSX.writeFile(workbook, "LowFareHotels_Report.xlsx");
  };

  // Calculate pagination values
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredTransactions.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredTransactions.length / recordsPerPage);

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 2) {
        end = 4;
      } else if (currentPage >= totalPages - 1) {
        start = totalPages - 3;
      }

      if (start > 2) {
        pageNumbers.push("...");
      }

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      if (end < totalPages - 1) {
        pageNumbers.push("...");
      }

      pageNumbers.push(totalPages);
    }
    return pageNumbers;
  };

  return (
    <>
      <HeaderDashboard />

      <div className="toolbar py-2" id="kt_toolbar">
        <div className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1">
            <div className="page-title d-flex align-items-center flex-wrap">
              <h1 className="text-gray-900 fw-bold fs-3">Reports</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li className="breadcrumb-item text-muted">Hotel</li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-gray-900">
                  Lowfare Hotels
                </li>
              </ul>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <div className="flex-shrink-0 me-2 d-none-mob">
              <ul className="nav" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.history.back();
                    }}
                  >
                    <img src="/assets/images/back.png" width={30} alt="back" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .ui-datepicker {
          z-index: 9999 !important;
        }
      `}</style>
      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row g-3">
            <div className="col-md-2">
              <label className="form-label fw-bold">From Date</label>
              <input
                type="text"
                id="fromDate"
                className="form-control"
                placeholder="From Date"
                value={filters.fromDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold">To Date</label>
              <input
                type="text"
                id="toDate"
                className="form-control"
                placeholder="To Date"
                value={filters.toDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-bold">Reference No</label>
              <input
                className="form-control"
                type="text"
                name="referenceNo"
                value={filters.referenceNo}
                onChange={handleChange}
                placeholder="Reference No"
              />
            </div>
            
            <div className="col-md-2">
              <label className="form-label fw-bold" style={{ visibility: "hidden" }}>Search</label>
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading ? "..." : "Search"}
              </button>
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold" style={{ visibility: "hidden" }}>Clear</label>
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={handleClear}
                disabled={loading}
              >
                Clear
              </button>
            </div>
          </div>
        </div>

        <div className="box_shadow mt-4">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap" style={{ gap: "15px" }}>
            <div>
              <button
                type="button"
                className="btn btn-sm btn-success px-4"
                style={{ backgroundColor: "#17c752", borderColor: "#17c752", fontWeight: "600" }}
                onClick={handleExportExcel}
              >
                <i className="fa fa-file-excel me-2"></i> Excel
              </button>
            </div>
            <div className="position-relative" style={{ width: "300px" }}>
              <input
                type="text"
                className="form-control"
                style={{ paddingLeft: "35px" }}
                placeholder="Search Ref No, Hotel, Corporate..."
                value={globalSearch}
                onChange={(e) => {
                  setGlobalSearch(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <span className="position-absolute top-50 translate-middle-y ms-3" style={{ left: 0 }}>
                <i className="fa fa-search text-muted"></i>
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table align-middle gs-0 gy-4 table-hover">
              <thead>
                <tr className="fw-bold bg-light">
                  <th className="ps-4">Sr No</th>
                  <th>Ref No.</th>
                  <th>Created On</th>
                  <th>Corporate Name</th>
                   <th>Corporate code</th>
                  <th>Selected Hotel</th>
                  <th>Recommended Hotel</th>
                  <th>Option Selected</th>
                  <th>Saved Price</th>
                  <th>Missed Price</th>
                  {/* <th>Created By</th> */}
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.length > 0 ? (
                  currentRecords.map((item, index) => (
                    <tr key={index}>
                      <td className="ps-4">{indexOfFirstRecord + index + 1}</td>
                      <td>
                        <span className="text-gray-800 fw-bold">
                          {item.referenceNo || item.ReferenceNo || "-"}
                        </span>
                      </td>
                      <td>
                        <span className="text-gray-600">
                          {item.createdOn || item.CreatedOn
                            ? new Date(item.createdOn || item.CreatedOn).toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit"
                              })
                            : "-"}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          <span className="text-gray-800 fw-semibold">
                            {item.corporateName || item.CorporateName || "-"}
                          </span>
                         
                        </div>
                      </td>
                       <td>
                        <div className="d-flex flex-column">
                         
                          <span className="text-muted fs-7">
                            Code: {item.corporateCode || item.CorporateCode || "-"}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          <span className="text-gray-800 fw-semibold">
                            {item.selectedHotelName || item.SelectedHotelName || "-"}
                          </span>
                          <span className="text-gray-600 fs-7">
                            Price: ₹ {Number(item.selectedPrice || item.SelectedPrice || 0).toLocaleString()}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          <span className="text-gray-800 fw-semibold">
                            {item.recommendedHotelName || item.RecommendedHotelName || "-"}
                          </span>
                          <span className="text-gray-600 fs-7">
                            Price: ₹ {Number(item.recommendedPrice || item.RecommendedPrice || 0).toLocaleString()}
                          </span>
                        </div>
                      </td>
                      <td>
                        {item.selectedOption?.toLowerCase() === "recommended" ? (
                          <span className="badge badge-light-success fw-bold px-3 py-2" style={{ color: "#50CD89", backgroundColor: "#E8FFF3" }}>
                            Recommended
                          </span>
                        ) : item.selectedOption?.toLowerCase() === "original" ? (
                          <span className="badge badge-light-primary fw-bold px-3 py-2" style={{ color: "#009EF7", backgroundColor: "#F1FAFF" }}>
                            Original
                          </span>
                        ) : (
                          <span className="badge badge-light-secondary fw-bold px-3 py-2">
                            {item.selectedOption || "-"}
                          </span>
                        )}
                      </td>
                      <td>
                        {Number(item.savingPrice || item.SavingPrice || 0) > 0 ? (
                          <span className="text-success fw-bold">
                            ₹ {Number(item.savingPrice || item.SavingPrice).toLocaleString()}
                          </span>
                        ) : (
                          <span className="text-gray-600">-</span>
                        )}
                      </td>
                      <td>
                        {Number(item.missingPrice || item.MissingPrice || 0) > 0 ? (
                          <span className="text-danger fw-bold">
                            ₹ {Number(item.missingPrice || item.MissingPrice).toLocaleString()}
                          </span>
                        ) : (
                          <span className="text-gray-600">-</span>
                        )}
                      </td>
                      {/* <td>
                        <span className="text-gray-800">
                          {item.createdBy || item.CreatedBy || "-"}
                        </span>
                      </td> */}
                      <td>
                        <span className="text-gray-600 fs-7" title={item.remark || item.Remark}>
                          {item.remark || item.Remark || "-"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center py-5">
                      {loading ? (
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        <span className="text-muted">
                          No transactions found
                        </span>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          {transactions.length > 0 && (
            <div className="d-flex justify-content-between align-items-center flex-wrap mt-4 border-top pt-4">
              <div className="text-muted fs-7 mb-2">
                Showing <span className="fw-bold text-gray-800">{indexOfFirstRecord + 1}</span> to{" "}
                <span className="fw-bold text-gray-800">
                  {Math.min(indexOfLastRecord, transactions.length)}
                </span> of{" "}
                <span className="fw-bold text-gray-800">{transactions.length}</span> entries
              </div>
              <nav aria-label="Table pagination">
                <ul className="pagination pagination-circle pagination-outline justify-content-end mb-0" style={{ gap: "4px" }}>
                  <li className={`page-item previous ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
                    >
                      <i className="fa fa-chevron-left fs-8"></i>
                    </button>
                  </li>
                  {getPageNumbers().map((page, index) => {
                    if (page === "...") {
                      return (
                        <li key={`ellipsis-${index}`} className="page-item disabled">
                          <span className="page-link border-0">...</span>
                        </li>
                      );
                    }
                    return (
                      <li
                        key={page}
                        className={`page-item ${currentPage === page ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(page)}
                          style={{
                            backgroundColor: currentPage === page ? "#110942" : "transparent",
                            borderColor: currentPage === page ? "#110942" : "",
                            color: currentPage === page ? "#fff" : "",
                            fontWeight: currentPage === page ? "600" : "400"
                          }}
                        >
                          {page}
                        </button>
                      </li>
                    );
                  })}
                  <li className={`page-item next ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      style={{ cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}
                    >
                      <i className="fa fa-chevron-right fs-8"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default LowFareHotels;
